import { render, staticRenderFns } from "./SaleRecovery.vue?vue&type=template&id=6dc4a2f0&scoped=true&"
import script from "./SaleRecovery.vue?vue&type=script&lang=js&"
export * from "./SaleRecovery.vue?vue&type=script&lang=js&"
import style0 from "./SaleRecovery.vue?vue&type=style&index=0&id=6dc4a2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc4a2f0",
  null
  
)

export default component.exports